/******************************************************************/
/* Globals
/******************************************************************/

const isBCollection = () => {
    return window.sessionStorage.getItem('_1nk5732c011ct') == 'true';
}

const STORAGE_KEY = 'scroll-position-y';
let currency = window.Shopify.currency.active;
let currencyRate = window.Shopify.currency.rate;

if (window.Shopify.currency.active == "EUR") {
  currency = "€";
}

// elbDev - quantity discount progress bar
const quantityDiscountCart = document.querySelector('.ed-quantity-discount-cart');

// elbDev - lottery cart
const lotteryCart = document.querySelector('.ed-lottery-cart');

/******************************************************************/
/* Rivets.js adaptions 
/******************************************************************/

// price format
rivets.formatters.currency = function (value) {
  let price = (value / 100).toFixed(2) + ' ' + currency;
  let priceWithComma = price.replace(".", ",");

  return priceWithComma;
};

// price data format
rivets.formatters.currencyData = function (value) {
  let price = (value / 100).toFixed(2);

  return price;
};

// image size
rivets.formatters.mediumImageSize = function (src) {
  if (src !== null) {
    let size = '250x';

    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
        return '_' + size + match;
      })
  }
};

// Tattoo-Customizer: generiertes Design (Line-Property _ed_design_url) hat im Cart
// Vorrang vor dem Produktbild. Greift nur, wenn die Property gesetzt ist — normale
// Artikel fallen aufs Produktbild zurück. Die Design-URL NICHT durch mediumImageSize
// schicken (externe URL mit Query-Params; das Resize-Regex würde sie zerstören).
rivets.formatters.cartLineImage = function (item) {
  if (item && item.properties && item.properties._ed_design_url) {
    return item.properties._ed_design_url;
  }

  return rivets.formatters.mediumImageSize(item ? item.image : null);
};

// Tattoo-Customizer: im Cart zurück zur Customizer-Page verlinken (es gibt keine
// echte PDP). Fällt für normale Artikel auf die Produkt-URL zurück.
rivets.formatters.cartLineUrl = function (item) {
  if (item && item.properties && item.properties._ed_tc_url) {
    return item.properties._ed_tc_url;
  }

  return item ? item.url : '#';
};

// rivets cart on click plus/minus update quantity
rivets.binders["on-click"] = function (el, value) {
  el.onclick = function () {

    document.dispatchEvent(new CustomEvent('cartItemAdded'));

    // get cart quantity of minus or plus button
    let rivetsQuantity = el.dataset.cartQuantity;

    /* Upsell */
    if (rivetsQuantity == 0) {
      const upsells = document.querySelector('.cart__upsell-items');
      
      if (upsells) {
        let itemId = el.getAttribute('data-product-id');
        let upsellItem = document.querySelector('.cart__upsell-item[data-product-id="' + itemId + '"]');
  
        if (upsellItem) {
          upsellItem.classList.remove('hide');
        }

        const activeUpsells = document.querySelectorAll('.cart__upsell-item:not(.hide)');
    
        if (activeUpsells.length) {
          upsells.classList.remove('hide');
        
        } else {
          upsells.classList.add('hide');
        }
      }
    }
    /* /Upsell */
            
    // add facebook pixel AddToCart Event
    if (this.classList.contains('cart__button__plus')) {
      fbq('track', 'AddToCart', {
        content_ids: '[' + this.dataset.id + ']',
        value: this.dataset.finalPrice,
        num_items: 1,
        content_name: this.dataset.productTitle,
        currency: 'EUR',
        content_category: this.dataset.productType,
      });

      //klaviyo add to cart event
      let item = {
        Name: this.dataset.name,
        ProductID: parseInt(this.dataset.cartProductId),
        ImageURL: this.dataset.imageUrl,
        URL: 'https://' + window.location.host + this.dataset.url,
        Brand: this.dataset.brand,
        Price: this.dataset.price,
        CompareAtPrice: this.dataset.compareAtPrice
      };

      _learnq.push(['track', 'Added to Cart', item]);
    }

    for (let item of document.querySelectorAll(
      ".section-collection-page .product .product__buttons"
    )) {
      // check if product is equal cart product
      if (el.dataset.productId == item.dataset.variant) {
        // update quantity value of product dataset quantity
        item.querySelectorAll(".product__quantity")[0].dataset.quantity = rivetsQuantity;

        // update quantity text value of product quantity
        setTimeout(function () {
          item.querySelectorAll(".product__quantity")[0].textContent = rivetsQuantity;
        }, 600);

        // hide minus button + quantity text value if product quantity is 0
        if (item.querySelectorAll(".product__quantity")[0].dataset.quantity == 0) {
          setTimeout(function () {
            item.querySelectorAll(".product__button__minus")[0].style.display = "none";
            item.querySelectorAll(".product__quantity")[0].style.display = "none";
          }, 600);
        }
      }
    }
  };
};

// update quantity values on load if products are shown in cart
window.addEventListener('load', function () {
  for (let cartQuantityItem of document.querySelectorAll(
    ".cart .cart__buttons .cart__quantity"
  )) {

    // get cart quantity
    let rivetsQuantity = cartQuantityItem.textContent;

    for (let item of document.querySelectorAll(
      ".section-collection-page .product .product__buttons"
    )) {
      // check if product is equal cart product
      if (cartQuantityItem.dataset.productId == item.dataset.variant) {

        // update quantity value of product dataset quantity
        item.querySelectorAll(".product__quantity")[0].dataset.quantity = rivetsQuantity;

        // update quantity value of product dataset quantity
        item.querySelectorAll(".product__quantity")[0].textContent = rivetsQuantity;

        // show button minus + product quantity
        item.querySelectorAll(".product__button__minus")[0].style.display = "block";
        item.querySelectorAll(".product__quantity")[0].style.display = "block";
      }
    }
  }
})

/******************************************************************/
/* Discount
/******************************************************************/

$(document).on('cart.ready', function (event, cart) {
  let totalCount = cart.item_count;
  let totalPrice = cart.total_price;

  $('.Header__CartCount').text(totalCount);

  checkIfCartHasProducts(totalCount);
  discount(totalCount, totalPrice);

  // elbDev - get compare at prices
  updateCompareAtPriceForCartItems(cart);


  //remove free lottery product
  let lotteryCartElementExists = document.querySelector('.ed-lottery-cart');

  if(!lotteryCartElementExists) {
    let edDeactivatedLotteryProduct = document.querySelector('.ed-remove-lottery-product');
    if (edDeactivatedLotteryProduct) {
      let edRemoveLotteryProduct = edDeactivatedLotteryProduct.getAttribute('data-remove-free-product');

      var edRemoveLotteryProductElement = document.querySelector('.cart__product[data-product-id="' + edRemoveLotteryProduct + '"]');

      if (edRemoveLotteryProduct && edRemoveLotteryProductElement) {
        CartJS.removeItemById(edRemoveLotteryProduct);
      }
      else {
        console.log("free lottery product already removed");
      }
    }
  }
});

$(document).on('cart.requestComplete', function (event, cart) {
  let totalCount = cart.item_count;
  let totalPrice = cart.total_price;

  $('.Header__CartCount').text(totalCount);

  // add cartdot icon if products are in cart
  for (let cartDot of document.querySelectorAll('.Header__CartDot ')) {
    cartDot.classList.add('is-visible');
  }

  if (totalCount == 0) {
    for (let cartDot of document.querySelectorAll('.Header__CartDot ')) {
      cartDot.classList.remove('is-visible');
    }

    for (let item of document.querySelectorAll(".section-collection-page .product .product__buttons")) {
        // show button minus + product quantity
        item.querySelectorAll(".product__button__minus")[0].style.display = "none";
        item.querySelectorAll(".product__quantity")[0].style.display = "none";
    }
  }

  checkIfCartHasProducts(totalCount);
  discount(totalCount, totalPrice);

  // elbDev - get compare at prices
  updateCompareAtPriceForCartItems(cart);
});

function updateCompareAtPriceForCartItems(cart) {
  const cartContainer = document.querySelector('.cart__products');
  const compareAtPrices = document.querySelectorAll('.cart__product-discount-price');
  const prices = document.querySelectorAll('.cart__product-price');
  compareAtPrices.forEach(el => el.innerHTML = '');
  prices.forEach(el => el.style.color = '');

  cart.items.forEach(function(item) {
    $.getJSON(window.Shopify.routes.root + 'products/' + item.handle + '.js', function(product) {
      let matchingVariant = product.variants.find(v => v.id === item.variant_id);
      if (matchingVariant.compare_at_price > matchingVariant.price) {
        let itemElement = cartContainer.querySelector(`[data-product-id="${item.variant_id}"]`);

        if (itemElement) {
          let priceSpan = itemElement.querySelector('.cart__product-price');
          let discountSpan = itemElement.querySelector('.cart__product-discount-price');

          if (discountSpan && discountSpan.classList.contains('cart__product-discount-price')) {
            priceSpan.style.color = getComputedStyle(document.documentElement).getPropertyValue('--product-sale-price-color');
            discountSpan.innerHTML = ((matchingVariant.compare_at_price / 100) * item.quantity).toFixed(2) + " €";
          }
        }
      }
    });
  });
}

function discount(totalCount, totalPrice) {
  let tattooUniqueValue = document.querySelector('.cart__hidden-text-values').dataset.tattooUniqueValue;
  let tattooMultipleValue = document.querySelector('.cart__hidden-text-values').dataset.tattooMultipleValue;

  //discount values
  // let firstDiscountValue = parseFloat(document.querySelector('.cart').dataset.firstDiscount) / 100;
  // let secondDiscountValue = parseFloat(document.querySelector('.cart').dataset.secondDiscount) / 100;

  //shipping rate values for any country
  let shippingRateValue = parseFloat(document.querySelector('.cart__hidden-text-values').dataset.shippingRateValue.replace(",", ".")) * currencyRate;
  let shippingRateLabel = shippingRateValue.toFixed(2).toString().replace(".", ",") + ' ' + currency;

  //shipping rate values for switzerland
  let shippingRateValueCHF = parseFloat(document.querySelector('.cart__hidden-text-values').dataset.shippingRateValueChf.replace(",", "."));
  let shippingRateLabelCHF = shippingRateValueCHF.toFixed(2).toString().replace(".", ",") + ' ' + currency;

  let freeShippingLabel = document.querySelector('.cart__hidden-text-values').dataset.freeShippingLabel;

  //total price + price for free ship values
  let priceForFreeShipping = parseFloat(document.querySelector('.cart__hidden-text-values').dataset.freeShippingValue * currencyRate);
  let totalPriceValue = parseFloat(totalPrice / 100).toFixed(2);

  //shipping info
  let shippingInfo = document.querySelector('.cart__hidden-text-values').dataset.shippingInfo + ' ' + Math.round(priceForFreeShipping) + ' ' + currency;
  let freeShippingInfo = document.querySelector('.cart__hidden-text-values').dataset.freeShippingInfo;


  const cartItems = document.querySelectorAll('.cart .cart__product');
  var cartItemsQuantites = 0;

  if (cartItems) {
    for (let cartItem of cartItems) {
      const cartItemQuantityValue = parseInt(cartItem.querySelector('.cart__quantity').innerHTML);
      cartItemsQuantites += cartItemQuantityValue;
    }
    var cartUpdateEvent = new CustomEvent('cartUpdate', { detail: cartItemsQuantites });
    document.dispatchEvent(cartUpdateEvent);
  }

  // elbDev - quantity discount progress bar
  if (quantityDiscountCart && document.body.classList.contains('ed-ab-ink-178')) {
    const firstMilestone = parseInt(document.querySelector('.ed-quantity-discount-cart [data-milestone-one]').dataset.milestoneOne);
    if (cartItemsQuantites >= firstMilestone) {
      setShippingRate('<span class="free-shipping">' + freeShippingLabel + '</span>', 0);
    } else {
      // show shipping rate from switzerland if currency == CHF
      if (currency == "CHF") {
        setShippingRate(shippingRateLabelCHF, shippingRateValueCHF);
      }
      else {
        setShippingRate(shippingRateLabel, shippingRateValue);
      }

      document.querySelector('.cart__discount-text').innerHTML = shippingInfo;
    }
  } else {
    if (totalPriceValue >= priceForFreeShipping) {
      // set shipping rate (only by threshold, e.g. 39€ – no longer by item count)
      setShippingRate('<span class="free-shipping">' + freeShippingLabel + '</span>', 0);

      document.querySelector('.cart__discount-text').innerHTML = freeShippingInfo;
    }
    else {
      // show shipping rate from switzerland if currency == CHF
      if (currency == "CHF") {
        setShippingRate(shippingRateLabelCHF, shippingRateValueCHF);
      }
      else {
        setShippingRate(shippingRateLabel, shippingRateValue);
      }

      document.querySelector('.cart__discount-text').innerHTML = shippingInfo;
    }
  }

  //  //step 1 info for free shipping
  // if (totalCount < 3) {
  //   let countValue = 3;
  //   let totalCountValue = countValue - totalCount;

  //   discountProgressText(totalCount,totalCountValue,'',firstTextValue,secondTextValue,tattooUniqueValue,tattooMultipleValue);

  //   // set shipping rate
  //   setShippingRate(shippingRateLabel, shippingRateValue);
  // }
  // //step 2 free shipping
  // else if (totalCount == 3) {       
  //   let countValue = 4;
  //   let totalCountValue = countValue - totalCount;

  //   discountProgressText(totalCount,totalCountValue,sixthTextValue,firstTextValue,thirdTextValue,tattooUniqueValue,tattooMultipleValue);
  // }
  // //step 3 15% discount
  // else if (totalCount >= 4) {
  //   let countValue = 6;
  //   let totalCountValue = countValue - totalCount;

  //   discountProgressText(totalCount,totalCountValue,seventhTextValue,firstTextValue,fourthTextValue,tattooUniqueValue,tattooMultipleValue);

  //   // show discount price
  //   showDiscountPrice()

  //   //calculate discount price
  //   discountCalculation(firstDiscountValue, true);
  // }

  // //step 4 20% discount
  // if (totalCount >= 6) {
  //   document.querySelector('.cart__discount-text').textContent = fifthTextValue;

  //   //calculate discount price
  //   discountCalculation(secondDiscountValue, true);
  // }

  // //progress bar
  progressBar(totalPriceValue, priceForFreeShipping);

  //tattoo wording
  tattooWording(totalCount, tattooUniqueValue, tattooMultipleValue);

  //total price calculation
  totalPriceCalculation();
}

function dispatchCartPriceAndFreeShippingEvent(totalPriceValue, priceForFreeShipping) {
  let currentCartPriceAndFreeShipping = new CustomEvent('cartPriceUpdated', {
    detail: {
      totalPriceValue,
      priceForFreeShipping
    }
  });

  document.dispatchEvent(currentCartPriceAndFreeShipping);
}

function progressBar(totalPriceValue, priceForFreeShipping) {
  let factor = 100 / priceForFreeShipping;
  let progress = totalPriceValue * factor;
  dispatchCartPriceAndFreeShippingEvent(totalPriceValue, priceForFreeShipping);

  if (progress >= 100) {
    progress = 100;
  }

  document.querySelector('.cart__discount-progress-background').style.width = progress + '%';
}

// function progressBar(totalCount) {
//   if (totalCount <= 3) {
//     let factor = 10;
//     let progressInPercent = totalCount * factor + '%';
//     document.querySelector('.cart__discount-progress-background').style.width = progressInPercent;
//     }
//     else if (totalCount == 4) {
//       let factor = 12.5;
//       let progressInPercent = totalCount * factor + '%';
//       document.querySelector('.cart__discount-progress-background').style.width = progressInPercent;
//     }
//     else if (totalCount == 5) {
//       let factor = 15;
//       let progressInPercent = totalCount * factor + '%';
//       document.querySelector('.cart__discount-progress-background').style.width = progressInPercent;
//     }

//     if (totalCount >= 6) {
//       let progressInPercent = '100%';
//       document.querySelector('.cart__discount-progress-background').style.width = progressInPercent;
//     }
// }

// function discountProgressText(totalCountOriginVal, totalCountValue, annotation, firstTextValue, secondTextValue, tattooUniqueValue, tattooMultipleValue ) {
//   let totalTattooWording;
//   let tattooWording;

//   if(totalCountValue == 1) {
//     tattooWording = tattooUniqueValue;
//   }
//   else {
//     tattooWording = tattooMultipleValue;
//   }

//   //total count tattoo wording
//   if(totalCountOriginVal == 1) {
//     totalTattooWording = tattooUniqueValue;
//   }
//   else {
//     totalTattooWording = tattooMultipleValue;
//   }

//   document.querySelector('.cart__total-count .cart__label').innerHTML = totalTattooWording;
//   document.querySelector('.cart__discount-text').innerHTML = annotation + firstTextValue + ' ' + ' ' + totalCountValue + ' ' + tattooWording + ' ' + secondTextValue;
// }

function tattooWording(totalCountOriginVal, tattooUniqueValue, tattooMultipleValue) {
  let totalTattooWording;

  //total count tattoo wording
  if (totalCountOriginVal == 1) {
    totalTattooWording = tattooUniqueValue;
  }
  else {
    totalTattooWording = tattooMultipleValue;
  }

  document.querySelector('.cart__total-count .cart__label').innerHTML = totalTattooWording;
}

function checkIfCartHasProducts(totalCount) {
  if (totalCount > 0) {
    document.querySelector('.cart').classList.add('has-products');
  }
  else {
    document.querySelector('.cart').classList.remove('has-products');
  }
}

function setShippingRate(shippingRateLabel, shippingRate) {
  document.querySelector('.cart .shipping-price').innerHTML = shippingRateLabel;
  document.querySelector('.cart .shipping-price').dataset.shippingPrice = shippingRate;
}

// function showDiscountPrice() {
//   for (let discountPrice of document.querySelectorAll(
//     ".cart .cart__products .cart__product-discount-price"
//   )) {
//     discountPrice.style.display = "inline-block";
//   }

//   //add line through class for original price
//   for (let productPrice of document.querySelectorAll(
//     ".cart .cart__products .cart__product-price"
//   )) {
//     productPrice.classList.add('line-through');
//   }
// }

// function hideDiscountPrice() {
//   for (let discountPrice of document.querySelectorAll(
//     ".cart .cart__products .cart__product-discount-price"
//   )) {
//     discountPrice.style.display = "none";
//   }

//   //remove line through class for original price
//   for (let productPrice of document.querySelectorAll(
//     ".cart .cart__products .cart__product-price"
//   )) {
//     productPrice.classList.remove('line-through');
//   }
// }

// function discountCalculation(discountValue, originalLinePrice) {
//    // calculate discount price
//    for (let productPrice of document.querySelectorAll(
//     ".cart .cart__products .cart__product-price"
//   )) {

//     let linePrice;

//     if (originalLinePrice == true) {
//       linePrice = parseFloat(productPrice.dataset.originalLinePrice);
//     }
//     else {
//       linePrice = parseFloat(productPrice.dataset.linePrice);
//     }

//     let totalLinePrice = linePrice - (linePrice * discountValue);
//     let formattedTotalLinePriceLabel = totalLinePrice.toFixed(2).replace(".", ",") + ' €';

//     productPrice.parentNode.querySelectorAll('.cart__product-discount-price')[0].innerHTML = formattedTotalLinePriceLabel;
//     productPrice.dataset.linePrice = totalLinePrice;
//   }
// }

function totalPriceCalculation() {
  let totalPrice = 0;

  for (let productPrice of document.querySelectorAll(
    ".cart .cart__products .cart__product-price"
  )) {
    totalPrice = totalPrice + parseFloat(productPrice.dataset.linePrice);
  }

  let formattedSubtotalForCalculation;
  formattedSubtotalForCalculation = totalPrice.toFixed(2);

  const cartForm = document.querySelector('.cart .cart__form');
  
  // const oneCentItemPrice = document.querySelector('.cart__product-price[data-line-price="0.01"]');

  // if (oneCentItemPrice && /\.01$/.test(formattedSubtotalForCalculation)) {

  //   if (cartForm) {
  //     cartForm.setAttribute('action', '/checkout?discount=oneCentOff');
  //   }
    
  //   formattedSubtotalForCalculation -= .01;
  //   totalPrice -= .01;
    
  // } else {
    
  //   if (cartForm) {
  //     cartForm.setAttribute('action', '/cart');
  //   }
  // }

  let formattedSubtotalLabel = totalPrice.toFixed(2).replace(".", ",") + ' ' + currency;

  //subtotal price
  document.querySelector('.cart .subtotal').dataset.subTotalPrice = formattedSubtotalForCalculation;
  document.querySelector('.cart .subtotal').innerHTML = formattedSubtotalLabel;

  //total price
  let shippingPrice = document.querySelector('.cart .shipping-price').dataset.shippingPrice;
  
  let formattedTotalPrice = parseFloat(formattedSubtotalForCalculation) + parseFloat(shippingPrice);
  let formattedTotalPriceLabel = formattedTotalPrice.toFixed(2).replace(".", ",") + ' ' + currency;

  //set totalPrice label
  document.querySelector('.cart .total').innerHTML = formattedTotalPriceLabel;

  /* Head: total price */
  let edTotalPrice = document.querySelector('.cart .cart__total-price');
  if(edTotalPrice) {
    edTotalPrice.innerHTML = formattedTotalPriceLabel;
  }
  /* /Head: total price */

  //check if cart has products and update total price
  if (document.querySelector('.cart').classList.contains('has-products') === false && edTotalPrice) {
    edTotalPrice.innerHTML = '0,00 ' + ' ' + currency;
  } else if(edTotalPrice) {
    edTotalPrice.innerHTML = formattedTotalPriceLabel;
  }

  calculateProgressBar();
}

function calculateProgressBar() {
  let cartItemsQuantites = 0;

  const cartItems = document.querySelectorAll('.cart .cart__product');

  if (cartItems) {
    
    for (let cartItem of cartItems) {
      const cartItemQuantityValue = parseInt(cartItem.querySelector('.cart__quantity').innerHTML);
      cartItemsQuantites += cartItemQuantityValue;
    }
  }

  /* Progress bar */
  const progressBarsWrapper = document.querySelector('.cart .cart__progress-bars');

  if (progressBarsWrapper) {
    progressBarsWrapper.setAttribute('data-items-quantities', cartItemsQuantites);
    
    const progressBars = document.querySelectorAll('.cart .cart__progress-bar:not(.cart__progress-bar--combined)');
  
    const lastProgressBar = progressBars.length ? progressBars[progressBars.length - 1] : null;
    const lastProgressBarMinItems = lastProgressBar ? lastProgressBar.getAttribute('data-min-items') : null;
  
    for (let progressBar of progressBars) {
      const progressBarMinItems = progressBar.getAttribute('data-min-items');
      const progressBarMaxItems = progressBar.getAttribute('data-max-items');
      const progressBarTextNumber = progressBar.querySelector('.cart .cart__progress-bar__text span');
      
      const progressBarStepsActive = progressBar.querySelector('.cart__progress-bar__steps-active');
      if (progressBarStepsActive && lastProgressBarMinItems) {
        progressBarStepsActive.style.width = (cartItemsQuantites / lastProgressBarMinItems * 100) + '%';
      }
  
      if (progressBarTextNumber) {
        progressBarTextNumber.innerHTML = (progressBarMaxItems - cartItemsQuantites + 1);
      }
  
      if (cartItemsQuantites >= progressBarMinItems && cartItemsQuantites <= progressBarMaxItems) {
        progressBar.classList.remove('hide');
        
      } else {
        progressBar.classList.add('hide');
      }
    }
  }
  /* /Progress bar */
}

/* Upsell */
for (let element of document.querySelectorAll(".cart .cart__upsell-item__button")) {
  element.addEventListener("click", function () {
    const upsells = document.querySelector('.cart__upsell-items');
    document.dispatchEvent(new CustomEvent('cartItemAdded'));

    if (upsells) {
      const upsellItem = element.parentElement.parentElement;
      upsellItem.classList.add('hide');
      
      const activeUpsells = document.querySelectorAll('.cart__upsell-item:not(.hide)');
  
      if (activeUpsells.length) {
        upsells.classList.remove('hide');
      
      } else {
        upsells.classList.add('hide');
      }
    }
  },
    false
  );
}
/* /Upsell */

/* Upsell Buttons */

document.addEventListener('DOMContentLoaded', function() {
  const upsellWrapper = document.querySelector('.cart__upsell-items');
  const upsellItems = upsellWrapper.querySelectorAll('.cart__upsell-item');
  const leftArrow = document.querySelector('.left-arrow');
  const rightArrow = document.querySelector('.right-arrow');
  const itemWidth = 290;
  const predefinedPositions = [];
  for (let i = 0; i < upsellItems.length; i++) {
    predefinedPositions.push(itemWidth * i);
  }

  // Initial visibility check
  if (upsellItems.length > 0) {
    rightArrow.style.display = 'block';
  } else {
    rightArrow.style.display = 'none';
    leftArrow.style.display = 'none';
    return;
  }

  const tolerance = 5;
  upsellWrapper.addEventListener('scroll', () => {
    leftArrow.style.display = upsellWrapper.scrollLeft > 0 ? 'block' : 'none';

    if (Math.abs(upsellWrapper.scrollLeft + upsellWrapper.clientWidth - upsellWrapper.scrollWidth) < tolerance) {
      rightArrow.style.display = 'none';
    } else {
      rightArrow.style.display = 'block';
    }
  });

  function scrollUpsellList(direction) {
    const currentScroll = upsellWrapper.scrollLeft;

    let nextScrollPosition;
    if (direction > 0) {
      // Find the nearest position to the right
      const rightPositions = predefinedPositions.filter(position => position > currentScroll);
      if (rightPositions.length > 0) {
        nextScrollPosition = rightPositions[0];
      } else {
        nextScrollPosition = currentScroll;
      }
    } else {
      // Find the nearest position to the left
      const leftPositions = predefinedPositions.filter(position => position < currentScroll);
      if (leftPositions.length > 0) {
        nextScrollPosition = leftPositions[leftPositions.length - 1];
      } else {
        nextScrollPosition = currentScroll;
      }
    }

    const scrollDistance = nextScrollPosition - currentScroll;
    upsellWrapper.scrollBy({
      left: scrollDistance,
      behavior: 'smooth'
    });
  }

  leftArrow.addEventListener('click', () => scrollUpsellList(-1));
  rightArrow.addEventListener('click', () => scrollUpsellList(1));
});

/******************************************************************/
/* MOBILE
/******************************************************************/

for (let element of document.querySelectorAll(".cart .cart__head")) {
  element.addEventListener("click", function () {
    toggleCart(element);
  },
    false
  );
}

for (let element of document.querySelectorAll(
  ".cart .cart__empty .button-on-mobile"
)) {
  element.addEventListener("click", function () {
    closeMobileCart(element);
  },
    false
  );
}

function closeMobileCart(element) {
  if (window.matchMedia("(max-width: 767px)").matches) {
    //document.querySelector('.cart .cart__head').classList.remove('active');

    document.querySelectorAll('.cart .cart__head').forEach(function(element) {
      element.classList.remove('active');
    });

    document.querySelector('.cart').classList.remove('active');
    document.querySelector('html').classList.remove('mobile-cart-open');
  }
}

function toggleCart(element) {

  if (element.classList.contains('active')) {
    element.classList.remove('active');
  } else {
    element.classList.add('active');
  }

  document.querySelector('.cart').classList.toggle('active');
  document.querySelector('html').classList.toggle('mobile-cart-open');

  if (document.querySelectorAll('.cart-wrapper').length > 0) {
    document.querySelector('.cart-wrapper').classList.remove('open');
  }
}

/******************************************************************/
/* cart on other pages
/******************************************************************/

if (document.querySelectorAll('.trigger-cart').length > 0) {
  for (let triggerCart of document.querySelectorAll(".trigger-cart")) {
    triggerCart.addEventListener("click", function () {

      /* Sidebar cart */
      document.body.setAttribute('data-drawer-id-opened', 'shopify-section-cart');
      /* /Sidebar cart */
      
      if (document.querySelectorAll('.cart-wrapper').length > 0) {
        document.querySelector('.cart-wrapper').classList.add('open');
      }
      document.querySelector('.cart').classList.add('active');

      //document.querySelector('.cart .cart__head').classList.add('active');

      document.querySelectorAll('.cart .cart__head').forEach(function(element) {
        element.classList.add('active');
      });

      document.querySelector('html').classList.add('mobile-cart-open');
    }
    );
  }
}

//close desktop cart if clicked outside
document.addEventListener("click", function (e) {
  let target = e.target;

  if (target.matches(".cart-wrapper")) {
    document.querySelector('.cart-wrapper').classList.remove('open');
    document.querySelector('.cart').classList.remove('active');

    //document.querySelector('.cart .cart__head').classList.remove('active');

    document.querySelectorAll('.cart .cart__head').forEach(function(element) {
      element.classList.remove('active');
    });

    document.querySelector('html').classList.remove('mobile-cart-open');
  }
});

if (document.querySelectorAll('.Button__add-to-cart').length > 0) {
  document.querySelector('.Button__add-to-cart').addEventListener("click", function () {
    document.dispatchEvent(new CustomEvent('cartItemAdded'));

    if (window.globalEnableRedirectToCart) {
      document.querySelector('.cart-wrapper').classList.add('open');
      document.querySelector('.cart').classList.add('active');

      //document.querySelector('.cart .cart__head').classList.add('active');

      document.querySelectorAll('.cart .cart__head').forEach(function(element) {
        element.classList.add('active');
      });

      document.querySelector('html').classList.add('mobile-cart-open');
    }

    // return to previous page
    /** DISABLED BY ELBDEV
    if (document.querySelectorAll('.cart-wrapper').length > 0) {
      setTimeout(function () {
        if(document.documentElement.classList.contains('ed-ab-ink-6')) {
          return;
        }

          // remove after ABTEST
          if (!isBCollection()) {
              window.location.replace(document.referrer);
          }
      }, 1500);
    }
     **/
  });
}

/******************************************************************/
/* redirect cart page
/******************************************************************/

if (window.location.href.indexOf("/cart") > 0) {
  window.location.href = '/collections/all-products';
}